import { render, staticRenderFns } from "./packageItem.vue?vue&type=template&id=2e292423&scoped=true&"
import script from "./packageItem.vue?vue&type=script&lang=js&"
export * from "./packageItem.vue?vue&type=script&lang=js&"
import style0 from "./packageItem.vue?vue&type=style&index=0&id=2e292423&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e292423",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e292423')) {
      api.createRecord('2e292423', component.options)
    } else {
      api.reload('2e292423', component.options)
    }
    module.hot.accept("./packageItem.vue?vue&type=template&id=2e292423&scoped=true&", function () {
      api.rerender('2e292423', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/components/packageItem.vue"
export default component.exports